import styled from 'styled-components'

const Rotate = styled.div.withConfig({
  shouldForwardProp: prop => ![
    'active',
  ].includes(prop),
})`
  display: inline-flex;
  transition: ${props =>
    props.theme.internalMixins.setTransition(['transform'])};
  transform-origin: center center;
  transform: rotate(${props => (props.active ? '-180' : '-0')}deg);
`

export default Rotate
